import {
  Component,
  ElementRef,
  Input,
  SimpleChanges,
  ViewChild, Output
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { UiformBaseComponent } from '../uiform-base/uiform-base.component';

@Component({
  selector: 'app-uiform-graph',
  templateUrl: './uiform-graph.component.html',
  styleUrls: ['./uiform-graph.component.css']
})
export class UiformGraphComponent extends UiformBaseComponent {
  @ViewChild('content')
  content!: ElementRef;

  public target_name = 'chart';

  public loading: boolean = false;

  public cachedChartData: { [key: string]: any } = {}; // Cache to store chart data

  public usecaseSchema: any = {};

  public filteredAttributes: any = [];
  @Output() override isUserFilter: number = 0;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));
    if (route.snapshot.paramMap.get('formId')) {
      _self.uiformId = Number(route.snapshot.paramMap.get('formId'));
      _self.target_name = 'chart-custom';
    } else {
      _self.target_name = 'chart';
    }
    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['uiformId']) {
      this.ngOnInit(); // Call ngOnInit or relevant method only if uiformId changes
    }
  }

  override ngOnInit() {
    let _self = this;
    _self.isUserFilter=0;
    _self.checkUserAccess(_self.uiformId);
    _self.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        if (_self.uiformId) {
          this.get(_self.uiformId, function () {
            _self.usecaseId = _self.form.data.userstoryId;
            _self.getUsecaseSchema();
          });
        }
      });
  }

  resetSearchValues() {
    this.form.data.field = '';
  }

    async checkUserAccess(uiformId: any) {
    let _self = this;
    if (!uiformId && uiformId < 0) {
      return;
    }
    const keySuffix = localStorage.getItem('keySuffix');
    const appId = localStorage.getItem(keySuffix + 'appId');
    const applicationRoleId = localStorage.getItem(keySuffix + 'roleId');

    const searchParam = {
      applicationId: Number(appId),
      formId: Number(uiformId),
      applicationRoleId: Number(applicationRoleId),
    };

    _self.locator.config
      .getProperty('endpoint.application.role.usecase')
      .then((property: string) => {
        let url = property + '/search';
        this.locator.http.post(
          url,
          searchParam,
          async function (res: any, error: any) {
            if (error) {
              console.error('Server Error:' + error);
              return;
            }

            if (res.success) {
              let templist = res.result.data;
              if (templist.length > 0) {
                _self.isUserFilter = templist[0]?.userFilter;
              }
            }
          }
        );
      });
  }

  public drawChart() {
    let _self = this;
    //_self.loading = true;
    let code = this.form.data.field;
    if (code === undefined || code === '') {
      _self.filteredAttributes = _self.filterFieldsAttributes();
      return;
    }

    setTimeout(() => {
      let fields = _self
        .filterFieldsAttributes()
        .filter((e: any) => e.code === code);
      _self.filteredAttributes = _self.usecaseAttributes.filter(
        (attribute: any) => attribute.code === code && code !== 'undefined'
      );
    }, 100);
  }

  // filterFieldsAttributes(): any {
  //   let _self = this;
  //   const allowedTypes = [
  //     'text',
  //     'date',
  //     'number',
  //     'object',
  //     'email',
  //     'time',
  //     'url',
  //     'map',
  //     'textarea',
  //   ];
  //   let code = this.form.data.field;
  //   if (code === undefined || code === '') {
  //     const result = _self.usecaseAttributes.filter(
  //       (attr: any) =>
  //         _self.form.data['fields'].some(
  //           (field: any) => field.id === attr.id
  //         ) && allowedTypes.includes(attr['type'])
  //     );
  //     return result;
  //   }

  //   //List Filter Search
  //   const result = _self.usecaseAttributes.filter(
  //     (attribute: any) => attribute.code === code && code !== 'undefined'
  //   );
  //   return result;
  // }

  // /**
  //  * Filter Attribute Label
  //  * @returns
  //  */
  // public filterAttributeLabel(): any {
  //   let _self = this;
  //   // const allowedTypes = [
  //   //   'text',
  //   //   'date',
  //   //   'number',
  //   //   'object',
  //   //   'email',
  //   //   'time',
  //   //   'url',
  //   //   'map',
  //   //   'textarea',
  //   // ];
  //   const allowedTypes = ['date', 'list', 'time'];

  //   const result = _self.usecaseAttributes.filter(
  //     (attr: any) =>
  //       _self.form.data['fields'].some((field: any) => field.id === attr.id) &&
  //       allowedTypes.includes(attr['type'])
  //   );
  //   return result;
  // }

  filterFieldsAttributes(): any {
    let _self = this;
    const allowedTypes = ['date', 'list', 'time'];
    let code = this.form.data.field;
    if (code === undefined || code === '') {
      const result = _self.usecaseAttributes.filter(
        (attr: any) =>
          (_self.form.data['fields'].some(
            (field: any) => field.id === attr.id
          ) &&
            allowedTypes.includes(attr['type'])) ||
          _self.parentUsecaseList.some(
            (parentAttr: any) => parentAttr.id === attr.id
          )
      );
      return result;
    }

    //List Filter Search
    const result = _self.usecaseAttributes.filter(
      (attribute: any) => attribute.code === code && code !== 'undefined'
    );
    return result;
  }

  /**
   * Filter Attribute Label
   * @returns
   */
  public filterAttributeLabel(): any {
    let _self = this;
    const allowedTypes = ['date', 'time', 'list'];
    const result = _self.usecaseAttributes.filter(
      (attr: any) =>
        (_self.form.data['fields'].some((field: any) => field.id === attr.id) &&
          allowedTypes.includes(attr['type'])) ||
        _self.parentUsecaseList.some(
          (parentAttr: any) => parentAttr.id === attr.id
        )
    );
    return result;
  }

  /**
   * Row and Column Correction in row
   * @param index
   * @returns
   */
  isLastOdd(index: number): boolean {
    return (
      this.filterFieldsAttributes().length % 2 !== 0 &&
      index === this.filterFieldsAttributes().length - 1
    );
  }

}
